module.exports = __webpack_public_path__ + "static/media/stencil_toggle.63968466.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stencil_toggle.jpg
// module id = 1112
// module chunks = 0